<template><div><h1 id="refuses-retouren-bearbeitung" tabindex="-1"><a class="header-anchor" href="#refuses-retouren-bearbeitung"><span>Refusés/Retouren-Bearbeitung</span></a></h1>
<h2 id="grundsatzlich-gibt-es-folgende-moglichkeiten" tabindex="-1"><a class="header-anchor" href="#grundsatzlich-gibt-es-folgende-moglichkeiten"><span>Grundsätzlich gibt es folgende Möglichkeiten:</span></a></h2>
<h3 id="_1-datamatrix-der-schweizerischen-post" tabindex="-1"><a class="header-anchor" href="#_1-datamatrix-der-schweizerischen-post"><span>1. Datamatrix der Schweizerischen Post</span></a></h3>
<p>Der DataMatrix-Code der Schweizerischen Post ist ein zweidimensionaler Barcode, der vor allem für den Versand von Briefen, Rechnungen und Paketen verwendet wird. Er ermöglicht eine schnelle, automatisierte Verarbeitung durch Sortiermaschinen und vereinfacht die elektronische Frankierung
man kann auch definieren, was mit „Rücksendungen“ zu tun ist.</p>
<ul>
<li>z.B. direkt entsorgen falls nur Papier</li>
</ul>
<p>Der Code ist ein quadratischer 2D-Barcode (schwarz-weiss), der deutlich mehr Informationen speichern kann als ein herkömmlicher Strichcode.</p>
<p>Bei der Schweizerische Post enthält er unter anderem:</p>
<ul>
<li>Frankaturinformationen (Porto)</li>
<li>Absender- oder Kundennummer</li>
<li>Versandart (A-Post, B-Post usw.)</li>
<li>Zusatzleistungen (z. B. Einschreiben)</li>
<li>Technische Steuerdaten für die Sortierung</li>
</ul>
<p>Als Vorteil bekommt man ein „Datamatrix“-File wo drin steht, bei wem welcher Brief aus welchem Grund nicht zugestellt werden konnte oder wer die Sendung zurückgewiesen hat.</p>
<p>funtrade kann diese Files direkt verarbeiten. Dazu muss lediglich die Personen-Id in den Informationen vom DM-Code enthalten sein.</p>
<p>Falls du in der Druckerei / Lettershop druckst, kann dir deine Druckerei / dein Lettershop am besten Auskunft geben. Auch kann ein DM-Code mit funtrade über den Document-Output erstellt werden.</p>
<h3 id="_2-weitere-formate" tabindex="-1"><a class="header-anchor" href="#_2-weitere-formate"><span>2. Weitere Formate</span></a></h3>
<ul>
<li><strong>Liste mit QR-Referenzen</strong>: Ereignis und Ereignisposition werden direkt aus der QRR gelesen</li>
<li><strong>Liste mit PersonenIds</strong>: Refseé-Ereignis muss selber definiert werden (weniger genau)</li>
<li><strong>Spezialformate:</strong> und noch ein paar Spezialformate</li>
</ul>
<h2 id="einlesen-in-funtrade-halb-automatisch-uber-refuse-bearbeitung" tabindex="-1"><a class="header-anchor" href="#einlesen-in-funtrade-halb-automatisch-uber-refuse-bearbeitung"><span>Einlesen in funtrade: halb-automatisch über &quot;Refusé-Bearbeitung&quot;</span></a></h2>
<div class="hint-container warning">
<p class="hint-container-title">Wichtig</p>
<p>Damit damit funtrade ein Refusé registrieren kann, muss die Person bereits ein entsprechendes Initial-Ereignis besitzen. Falls das nicht der Fall ist, muss zuerst über einen <strong>Filter / Filterverknüpfung</strong> ein Initial erstellt werden oder die Sperren über einen regulären <strong>Adressimport in eigene Datenbank</strong> durchgeführt werden.</p>
</div>
<p>Pfad <code v-pre>Personen -&gt; Verarbeitungsläufe -&gt; Refusé-Bearbeitung</code></p>
<ol>
<li>neuen Verarbeitungslauf erstellen</li>
<li>Importformat wählen
<ul>
<li>Standard</li>
<li>Personen-Id</li>
<li>Datamatrix</li>
</ul>
</li>
<li>falls nötig: Ereignis konfigurieren</li>
<li>Daten einlesen</li>
<li>kontrollieren</li>
<li>Daten verarbeiten</li>
</ol>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<ul>
<li><RouteLink to="/referenz/refs/ft.refproc.refusee.html">Referenz: Refusés/Retouren-Bearbeitung</RouteLink></li>
</ul>
</div></template>


